import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  selectNotificationTemplates,
} from '../../../../redux/slices/notificationTemplatesSlice/notificationTemplatesSlice';

const MessageTemplateDropdown = ({
  createTemplate,
  updateField,
  alertEscalationActionTemplateSetId,
  disabled,
}) => {
  const templatesList = useSelector(selectNotificationTemplates);

  const updateTemplateId = (e) => {
    const { value } = e.target;
    if (value === '__create__') {
      createTemplate();
      return;
    }
    if (value === '-1') {
      updateField('templateId', null);
      return;
    }
    const newId = parseInt(e.target.value, 10);
    updateField('templateId', newId);
  };

  return (
    <div style={{ width: '230px' }}>
      <div className="row form-inline">
        <span
          className="col-12"
          style={{ fontWeight: 'bold', fontSize: '15px' }}
        >
          Message Template
        </span>
      </div>

      <div className="row form-inline-block">
        <div className="col-12">
          <select
            className="form-control"
            onChange={updateTemplateId}
            disabled={disabled}
            value={
                            alertEscalationActionTemplateSetId === null
                              ? -1
                              : alertEscalationActionTemplateSetId
                        }
            aria-label="message template"
          >
            <option value="-1">- None -</option>

            {templatesList.map((template) => (
              <option key={template.id} value={template.id}>
                {template.name}
              </option>
            ))}

            <option key="0" value="__create__">
              - New Template -
            </option>
          </select>
        </div>
      </div>
    </div>
  );
};

MessageTemplateDropdown.defaultProps = {
  alertEscalationActionTemplateSetId: null,
};

MessageTemplateDropdown.propTypes = {
  createTemplate: PropTypes.func.isRequired,
  updateField: PropTypes.func.isRequired,
  alertEscalationActionTemplateSetId: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
};

export { MessageTemplateDropdown };
export default MessageTemplateDropdown;
